// extracted by mini-css-extract-plugin
export var category = "category-Ylh";
export var no_results = "no_results-iFD";
export var result_header = "result_header-J+8";
export var result_wrapper = "result_wrapper-CQE";
export var search_field = "search_field-3O+";
export var search_wrapper = "search_wrapper-7Av";